import { Button, Icon, IconColor } from '@/dc-shared-web/src'
import { faCircleExclamation } from '@document-crunch/pro-regular-svg-icons'

interface ErrorStateProps {
  documentName?: string
  errorMessage?: string
  onBack: () => void
}

/**
 * Error state component for ProjectSight modal
 * Shows an error message when export to ProjectSight fails
 */
export const ErrorState: React.FC<ErrorStateProps> = ({
  documentName,
  errorMessage,
  onBack,
}) => {
  return (
    <>
      <div
        className='tw-flex tw-flex-col tw-items-center tw-justify-center'
        aria-live='assertive'
      >
        <div
          className='tw-w-full tw-bg-destructive-600 tw-border tw-border-destructive-400 tw-rounded-md tw-p-4'
          role='alert'
        >
          <div className='tw-flex tw-items-start'>
            <div className='tw-w-6 tw-h-6 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-mr-3 tw-flex-shrink-0'>
              <Icon
                icon={faCircleExclamation}
                color={IconColor.white}
                aria-hidden='true'
              />
            </div>
            <div>
              <p className='tw-text-destructive-foreground tw-font-medium tw-text-sm/[20px]'>
                Export Failed
              </p>
              <p className='tw-text-destructive-foreground tw-text-xs'>
                {errorMessage ||
                  (documentName
                    ? `${documentName} failed to export. Check your login credentials and try again.`
                    : 'Failed to export. Check your login credentials and try again.')}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className='tw-flex tw-justify-end tw-gap-2 tw-mt-3'>
        <Button
          type='button'
          variant='outline'
          onClick={onBack}
          aria-label='Go back to form after export failure'
        >
          Back
        </Button>
      </div>
    </>
  )
}

export default ErrorState
